import { ChainId } from '@xterswap/sdk-core'

export const BLOCK_LAG_THRESHOLD = {
  [ChainId.BNB]: 3,
  [ChainId.XTERIO]: 5,
  [ChainId.XTERIO_TESTNET]: 5,
}
